import React from 'react';
import { GridCell } from '@progress/kendo-react-grid';

import { Route, Link } from 'react-router-dom'
import {withStyles} from "@material-ui/styles";


// export default function cellWithEditing(edit, remove) {
//     return class extends GridCell {
//         render() {
//             return (
//                 <td>
//                     <Link to={{pathname:"/stock/transfers/" + this.props.itemState + "/detail/" + this.props.dataItem.id,  detailProps: {dataItem: this.props.dataItem}}}>OPEN</Link>
//                 </td>
//             );
//         }
//     };
// }




class OpenCell extends React.Component {
    render() {
        const value = this.props.dataItem[this.props.field];
        if(!this.props.dataItem.value) {
            return (

                <td>
                    <Link to={{
                        pathname: "/stock/transfers/" + this.props.itemState + "/detail/" + this.props.dataItem.id,
                        detailProps: {dataItem: this.props.dataItem}
                    }}>OPEN</Link>
                </td>
            );
        }
       return null;
    }
}

export default OpenCell;
